const widthMeasurer = document.createElement('div');
widthMeasurer.classList.add(
  'absolute',
  'p-2',
  'opacity-0',
  'pointer-events-none',
  'whitespace-nowrap'
);
document.body.append(widthMeasurer);

export const MAX_COLUMN_WIDTH = 30;

export const measureTextWidth = (
  text: string,
  options = { monospace: false }
) => {
  if (!text) {
    return 0;
  }
  if (options.monospace) {
    widthMeasurer.classList.add('font-mono');
  }
  widthMeasurer.textContent = text;
  const width = widthMeasurer.clientWidth;
  if (options.monospace) {
    widthMeasurer.classList.remove('font-mono');
  }
  return Math.min(MAX_COLUMN_WIDTH, Math.ceil(width / 16 + 0.5));
};

export const getMaxWidth = (strings: string[]) =>
  strings.reduce((max, s) => {
    const nextWidth = measureTextWidth(s);
    return nextWidth > max ? nextWidth : max;
  }, 0);



// WEBPACK FOOTER //
// ./src/services/links/measureTextWidth.ts